'use client';

import { styled } from '../../../../styles';

export const DatePickerHeaderContainer = styled.div(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  overflow: 'hidden',
}));

export const DatePickerHeaderActions = styled.div(
  () =>
    ({
      display: 'flex',
      position: 'absolute',
    } as const),
);

export const DatePickerHeaderActionsStart = styled(DatePickerHeaderActions)(
  () => ({
    left: 0,
  }),
);

export const DatePickerHeaderActionsEnd = styled(DatePickerHeaderActions)(
  () => ({
    right: 0,
  }),
);
